import { Reducer } from 'redux';
import { CoreState, CoreActionTypes } from './types';
import { StudentActionTypes } from '../types';
import { AuthActionTypes } from '../../auth/types';

const initialState: CoreState = {
  student_id: '',
  student_number: '',
  email: '',
  university: '',
  createdAt: 0,
  updatedAt: 0,
  infoProcessingConsent: false,
  legalAdviseDisclaimer: false,
  casIssued: false
};

const reducer: Reducer<CoreState> = (state = initialState, action) => {
  switch (action.type) {
    case AuthActionTypes.COGNITO_LOGIN_SUCCESS: {
      const { email, studentNo, uni } = action.payload.sessionContext;
      return {
        ...state,
        student_number: studentNo,
        university: uni,
        email: email
      };
    }
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return { ...state, ...action.payload.student.core };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.SAVE_DOCUMENTS_SUCCESS:
    case StudentActionTypes.SAVE_FOLLOW_UP_DOCUMENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS:
      return { ...state, ...action.payload.core };
    case CoreActionTypes.UPDATE_LEGAL_ADVISE_DISCLAIMER:
      return {
        ...state,
        legalAdviseDisclaimer: action.payload
      };
    case CoreActionTypes.UPDATE_INFO_PROCESSING:
      return {
        ...state,
        ...action.payload.config.Checklist.defaultOverrides.core,
        infoProcessingConsent: action.payload.value
      };
    default:
      return state;
  }
};

export { reducer as coreReducer };
